/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Card Size Switcher javascript
//
// Listens for *change* events on [data-action="card-size-change"] (note: this is not a *click* event, as the markup
// uses radio buttons) and swaps in the appropriate class for the card size, as specified in +data-card-size+.

namespace('Slzr.Theme', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return $(document).on('change', '[data-action="card-size-change"]', function(event) {
    return $('.em-card-group')
      .removeClass('em-card-group--small em-card-group--medium em-card-group--big')
      .addClass(`em-card-group--${$(this).data('card-size')}`);
  });
});
